import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import ContactQualificationAiQualification from '../../enums/contact/contact_qualification_ai/ContactQualificationAiQualification';
import { JobType } from "@leedpulse-monorepo/enums";
import { ESmsRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface SendMessagePayload {
    sResponseType: JobType;
    sUserText?: string;
    aSMS?: MessagePayload[];
    oContact: ContactPayload;
}

export interface MessagePayload {
    created: number;
    role: ESmsRole;
    message: string;
    qualification: ContactQualificationAiQualification;
}

export interface ContactPayload {
    id_api_key: string;
    contact: ContactDetailsPayload;
}

export interface ContactDetailsPayload {
    firstname: string;
    lastname: string;
    owner: string;
    prospect_category: string;
    details: string;
    /** Optional - defaults to 'M_MME' in demo for neutral tone */
    civility?: string;
    /** Optional - defaults to '33600000000' in demo for French language context */
    sender?: string;
}

export interface OriginalPromptData {
    role: string;
    content: string;
}

export interface SendMessageData {
    response: string;
    original_prompt: OriginalPromptData[];
    qualification_ai: any;
}

export interface SendMessageResponse {
    success: boolean;
    statusCode: number;
    statusResponse: string;
    data: SendMessageData;
}

async function sendMessageToAI(
    payload: SendMessagePayload,
    auth: Authentication
): Promise<SendMessageResponse> {
    try {
        const response = await HttpClient.post(
            '/scenario/demo/chat',
            payload,
            auth.token,
            false,
            {
                'x-api-key': payload.oContact.id_api_key,
                'Content-Type': 'application/json'
            }
        );

        if (response.success) {
            return response;
        } else {
            console.log('error: ', response);
            throw new SendMessageToAIFailure();
        }
    } catch (e) {
        console.log('error: ', e);
        throw new SendMessageToAIFailure();
    }
}

export class SendMessageToAIFailure extends Failure {
    constructor(message = 'Unknown error', code = 'unknown-error') {
        super(message, code);
    }
}

export default sendMessageToAI;
